// FB38607-Pawan Prajapati
export const DataEntity = {
  LetterOfCredit: 'LetterOfCredit',
  CashCollateral: 'CashCollateral',
  CIPolicy: 'CIPolicy',
  ParentCounterpartyGuarantee: 'ParentCounterpartyGuarantee',
  TradeNettingContract: 'TradeNettingContract',//FB48669-Pawan Prajapati
  CreditSupportAnnex: 'CreditSupportAnnex'
}

//FB48669-Pawan Prajapati
export const DataEntityIds = {
  TradingCounterparty: 1,
  TradingEntity: 2,
  ParentCounterpartyGuarantee: 11,
  CallMemo: 18,
  CashCollateral: 19,
  CreditSupportAnnex: 25,
  TradeNettingContract: 37,
  LetterOfCredit: 59,
  NettingContractClause: 93,
  CFAFacility: 268,
  CIPolicy: 289,
  DealNumber: 556,
  TradeLeg: 557,
  Shipment: 558,
  Parcel: 559

}

export enum ApiEndPoints {
  LetterOfCredit = 'LetterOfCredit',
  Counterparty = 'Counterparty',
  CounterpartyLimit = 'CounterpartyLimit',
  CashCollateral = 'CashCollateral',
  DataTransferEngine = 'DataTransferEngine',
  DealBasedTrade = 'DealBasedTrade',//FB48669-Pawan Prajapati
  LCReceivable = 'LCReceivable',
  Discounting = 'Discounting',
  DataTransferEngineTrigger = 'DataTransferEngineTrigger',//Jailani M M
  CollateralTracker = 'CollateralTracker'//Jailani M M
}
export class MailTemplateConstants {
  public static OnSuccess: string = 'Mail template saved successfully';
  public static OnError: string = 'Mail Template failed to save. Please see the event log/viewer for more information.';
  public static Error: string = 'Error';
  public static Ok: string = 'Ok';
  public static Success: string = 'Success';
  public static Empty: string = '';
  public static TemlateName: string = 'Template name';
  public static Subject: string = 'Subject';
  public static BodyName: string = 'Body';
  public static FromAddress: string = 'From Address';
  public static Password: string = 'Password';
  public static IsMandaroy: string = 'is mandatory.';
  public static ShouldBeValid: string = 'should be valid.';
  public static RemoveConfirmation: string = 'Do you want to remove';
  public static Confirmation: string = 'Confirmation';
  public static OnDeleteSuccess: string = 'Mail template deleted successfully.';
  public static OnDeleteError: string = 'Mail Template failed to delete. Please see the event log/viewer for more information.';
  public static Yes: string = 'Yes';
  public static No: string = 'No';
  public static Comma: string = ',';
  public static Quote: string = '\'';
  public static Space: string = ' ';
  public static MailTemplateNameShouldBeUnique: string = "Template name should be unique.";
}
export const Constants = {
  MailTemplate: MailTemplateConstants,
  LC_FEES_MANDATORY_CONDITION: "Fees, Condition and Period in Days are mandatory in Fees Conditions Tab",
  EXTERNALSOURCE_AESKEY: "Cuuube Looogic19",
  COUNTERPARTY_FEES_MANDATORY_CONDITION: "LC/Bank Guarantee, Calendar Type, Fees, Condition and Period in Days are mandatory in KYC Tab",
  COUNTERPARTY_FEES_CALENDARTYPE_CONDITION: "Calendar Type should be same for all rows in KYC Tab for ",
  COUNTERPARTY_FEES_DUPLICATE_CONDITION: "There is a duplicate record for the Condition and Period in KYC Tab, please check the record",
  LC_FEES_DUPLICATE_CONDITION: "There is a duplicate record for the Condition and Period in Fees Conditions Tab, please check the record",
  LC_STATUS_VALIDATION_DEALBASED: 'LC status is mandatory for Deal Based LC.',
  LC_STATUS_VALIDATION_PENDING_APPROVAL_EXPIRED_CONDITION: 'LC Status cannot be changed from Pending approval to Expired and vice versa.',
  SUCCESS: 'Success',
  FAILURE: 'Failure',
  FILE_CONFIGURATION_MISSING: 'File_Configuration_Missing',
  FILE_CONFIGURATION_ERRORMESSAGE: 'Please set up file configuration in FileProvider table in the database.',
  FILEUPLOAD_ERRORMESSAGE: 'Error occured while updating the documents. Please see eventLog table for more information',
  SHORTNAME_UNIQUENESS_MESSAGE: "Short name should be unique.",
  LONGNAME_UNIQUENESS_MESSAGE: "Long name should be unique.",
  AGREEMENT_REFERENCE_UNIQUENESS_MESSAGE: 'Agreement Reference should be unique.',
  LC_REFERENCE_UNIQUENESS_MESSAGE: 'LC Reference should be unique.',
  SAVE_SUCCESS_MESSAGE: "Changes are saved successfully.",
  ERROR: "error",
  AFTER_SAVE: "After Save",
  HTTP: "http://",
  HTTPS: "https://",
  LOGOUT_MESSAGE: "If you logout, all unsaved information will be lost.<br><br>Are you sure you want to logout?",
  DATATYPE_DATETIME: "System.Data.SqlTypes.SqlDateTime", //FB38211-charles
  DATATYPE_SYSTEM_DATETIME: "System.DateTime", //FB38211-charles
  DATATYPE_INT: "System.Data.SqlTypes.SqlInt32", //FB38211-charles
  DATATYPE_Decimal: "System.Data.SqlTypes.SqlDecimal", //FB38211-charles
  OURENTITY_CONTACT_TAB: "Contact",
  OURENTITY_CREDIT_RATING_TAB: "Credit Rating",
  OURENTITY_KYC_TAB: "KYC",
  OURENTITY_LEGAL_HIERARCHY_TAB: "Legal Hierarchy",
  OURENTITY_CUSTOM_PROPERTIES_TAB: "Custom Properties",
  OURENTITY_SAVE_SUCCESS_MESSAGE: "Our Entity saved successfully.",
  OURENTITY_SAVE_FAILURE_MESSAGE: "Our Entity failed to save successfully.Please contact Administrator.",
  OURENTITY_SAVE_NOTIFICATION_MESSAGE: "Please save our entity before adding ownership details.",
  OURENTITY_SAVE_NOTIFICATION_MESSAGE_CUSTOM_PROPERTIES: "Please save our entity before adding custom property details.",
  OURENTITY_TAB_CHANGE_NOTIFICATION_MESSAGE: "Before clicking on a tab, you will need to either:<br><br>Fill all mandatory fields on the General tab and hit Save<br><b>OR</b><br> Search for an Entity.",
  OECODE_UNIQUENESS_MESSAGE: "OE Code should be unique", //FB 35861
  BUSINESS_PROCESS_TYPE_SAVE_SUCCESS_MESSAGE: "Business Process Type saved successfully.",
  BUSINESS_PROCESS_TYPE_EXISTS_MESSAGE: "Business Process Type already exists.",
  BUSINESS_PROCESS_NAME_MANDATORY_CHECK: "Business Process Name is mandatory.",
  BUSINESS_PROCESS_TYPE_MANDATORY_CHECK: "Business Process Type is mandatory.",
  BUSINESS_PROCESS_MODEL_MANDATORY_CHECK: "Business Process Model is mandatory.",
  SCHEDULE_OCCURES_MANDATORY_CHECK: "Schedule occurs is mandatory.",
  RECURS_INTERVAL_MANDATORY_CHECK: "Recurs interval is mandatory.",
  DAY_OF_WEEK_MANDATORY_CHECK: "Day of week is mandatory.",
  DAY_OF_MONTH_MANDATORY_CHECK: "Day of month is mandatory.",
  OCCURS_TIME_MANDATORY_CHECK: "Occurs time is mandatory.",
  OCCURS_TIME_NOT_IN_FORMAT: "Occurs time is not in correct format.",
  SCHEDULE_START_DATE_MANDATORY_CHECK: "Schedule start date is mandatory.",
  SCHEDULE_END_DATE_MANDATORY_CHECK: "Schedule end date is mandatory.",
  SCHEDULE_END_DATE_COMPARE_CHECK: "Schedule end date should be greater than schedule start date.",
  SCHEDULE_FUNCTION_MANDATORY_CHECK: "Schedule functon is mandatory.",
  SCHEDULE_FUNCTION_PARAMETER_MANDATORY_CHECK: "Function parameter is mandatory.",
  TAB_NAME_MANDATORY_CHECK: "Tab name should be mandatory.",
  TAB_NAME_UNIQUE_CHECK: "Tab name should be unique.",
  STARTUP_RULE_MANDATORY_CHECK: "Start-up rule is mandatory.",
  BUSINESS_PROCESS_SAVE_FAILURE_MESSAGE: "Business process failed to save successfully.Please contact Administrator.",
  BUSINESS_PROCESS_SAVE_SUCCESS_MESSAGE: "Business process saved successfully.",
  MANDATORY_FIELDS_CHECK: "Please fill in the mandatory fields.",
  FAILURE_MESSAGE: 'Error has occured. Please see the event log for more information.',
  FAILURE_MESSAGE_CONTACT_ADMIN: 'Failed to save changes. Please contact Administrator.',
  PLEASE_FILL_THE_MANDATORY_FIELDS: 'Please fill the mandatory fields.',// FB38607-Pawan Prajapati
  TRADE_SELECTION_DISCARDED: 'Please save the changes before moving to next page or the selection will be discarded.',// CRD-97-Pawan Prajapati
  PLEASE_SELECT_SAME_TRADE_REFERENCE_MESSAGE: "You can either cover a Deal or a Contract, but not both. Please select the same Trade Reference (Deal or Contract) which was added previously.",// FB38607-Pawan Prajapati
  PLEASE_SELECT_SAME_TRADE_REFERENCE_MESSAGE_LC_and_CI: "The Hierarchy or {0} Assignment level cannot be changed, please delete all the assigned items from the main screen to enable the change in Hierarchy.",// FB38607-Pawan Prajapati
  THE_OVERALL_LIMIT_EXCEEDS_HEADROOM_LIMIT: "The Overall Limit exceeds the Headroom Limit. Please correct the limit values.",// FB30719607-Jailani M M
  THE_SUMOF_SUBLIMITS_EXCEEDS_OVERALL_LIMIT: "The sum of Sub-Limits exceeds the Overall Limit. Please correct the limit values.",// FB30719607-Jailani M M
  CI_REMOVE_COVERTED_COUNTERPARTY_VALIDATION_MESSAGE: "Counterparty: '{0}' cannot be removed as the Contracts/Deals associated with it is covered under Contract/Deal section. Please update the Contract/Deal section accordingly",
  DEALBASED_TRADE_NOTRADE_MESSAGE: "There are no more Trades or Legs or Shipments or Parcels available to be added",
  CI_DEALBASED_TRADE_NOTRADE_MESSAGE: "There are no more Trades available to be added",
  HEADROOM: "Headroom",
  OVERALL: "Overall",
  VOLUME: "Volume",
  PERMANENT_LIMIT: "Permanent limit ",
  VOLUME_LIMIT: "Volume limit (Buy-Sell) ",
  HEADROOM_LIMIT: "Headroom limit ",
  PERMANENTLIMIT: "permnentLimit",
  //Start FB46162-Pawan Prajapati
  TRADENETTING_CONTRACT_DEALBASED_TRADE_MANDATORY: "Select Counterparty and Our entity.",
  FourEyeRowId: '4Eye100',
  PERMANENT_CAN_NOT_UPDATE: "Permanent limit cannot be updated as there is an approval pending for Temporary limit.",
  TEMPORARY_CAN_NOT_UPDATE: "Temporary limit cannot be updated as there is an approval pending for Permanent limit.",
  DATAFIELD_LIMIT_VALUE: "LimitValue",
  DATAFIELD_CURRENCY_ID: "lLimitValueCurrencyId",
  DATAFIELD_UNIT_ID: "lUnitId",
  DATAFIELD_TENOR_TYPE_ID: "lTenorTypeId",
  DATAFIELD_NEW_LIMIT: "NewLimit",
  DATAFIELD_DELETE_LIMIT: "DeleteLimit",
  FOUR_EYE_FIRST_BG: '#F5EFDB',
  FOUR_EYE_SECOND_BG: '#FFF9E3',
  PENDING_APPROVAL_ROW_TEXT: 'Pending approval',
  NEW_LIMIT_LABEL: 'New limit',
  NEW_TEMP_LIMIT_LABEL: 'New temporary limit',
  DELETE_LIMIT_LABEL: 'Delete limit',
  DELETE_TEMP_LIMIT_LABEL: 'Delete temporary limit',
  MULTIPLE_LABEL: 'Multiple',
  TEMP_LIMIT_VALUE_CHANGE_LABEL: 'Temporary limit value change',
  FOUR_EYE_REQUEST_STATUS_PROPERTY: "FourEyeRequestStatus",
  FOUR_EYE_REQUEST_STATUS_TEMP_PROPERTY: "FourEyeRequestTempStatus",
  FOUR_EYE_ENABLED_MESSAGE: "The updates you made are Pending approval.",
  //End FB46162-Pawan Prajapati
  //Start FB47642-Pawan Prajapati
  APPROVE_ACTION: 'Approve',
  REJECT_ACTION: 'Reject',
  PERMISSION_SAVE: "Save permission is denied,please contact administrator. ",
  //End FB47642-Pawan Prajapati
  GROUP: 'group',//FB48669-Pawan Prajapati,
  MAXIMUM_LIMIT_OF_LIABILITY_CURRENCY_MANDATORY_CHECK: "Maximum Limit of Liability Currency is mandatory.",
  DISCRETIONARY_CREDIT_LIMIT_CURRENCY_MANDATORY_CHECK: "Discretionary Credit Limit (DCL) Currency is mandatory.",
  POLICY_DEDUCTIBLE_FIRST_LOSS_CURRENCY_MANDATORY_CHECK: "Policy Deductible/First Loss Currency is mandatory.",
  MINIMUM_PREMIUM_AMOUNT_CURRENCY_MANDATORY_CHECK: "Minimum Premium Amount Currency is mandatory.",
  MINIMUM_PREMIUM_CURRENCY_MANDATORY_CHECK: "Minimum Premium Currency is mandatory.",
  MailToAddressIsMandatory: "Mail To address is mandatory.",
  PleaseProvideFromAddress: "Please provide From address.",
  PleaseProvideFromAddressPassword: "Please provide From address password.",
  WouldYouLikeToUpdateTheCredentialsThatYouHaveEnteredForThisTemplateAsWellAsUseThemForSendingThisEmail: "Would you like to update the credentials that you have entered for this template as well as use them for sending this email?",
  Confirmation: "Confirmation",
  Yes: "Yes",
  No: "No",
  Ok: "Ok",
  Error: "Error",
  DoYouWantToUseSMTPConfiguredMailingCredentialsToEndEmail: "Do you want to use SMTP configured mailing credentials to send email?",
  PleaseProvideEmailCredentials: "Please provide email credentials.",
  DoYouWantToUseUserCredentialsToSendEmail: "Do you want to use User credentials to send email ?",
  InterestLetter: "InterestLetter",
  MarginLetter: "MarginLetter",
  SubstitutionLetter: "SubstitutionLetter",
  InterestCall: "Interest Call",
  MarginCall: "Margin Call",
  SubstitutionCall: "Substitution Call",
  Empty: "",
  TAB_REMOVAL_CONFIRMATION: "Are you sure, you want to remove tab ",
  LOCALE_EN_US: "en-US",
  ENTITY_ASSOCIATION: "EntityAssociation",
  ENTITY_ASSOCIATION_MESSAGE: "User does not have permission to Trading Entity",
  ENTITY_ASSOCIATION_MESSAGE_WITH_TRADING_ENTITY: "User does not have permission to {0} Trading Entity(s)",
  CHK_EVERGREEN: "chkEvergreen",
  DELETE_ALL_COVERED_TRADES_OR_AGREEMENTS_OF_PCG: "Please note that by reassigning the level of the guarantee you will also be reassinging the allocation level. This may have an impact on the offesetting of the risk metrics.",
  OPEN_URL_NEW_TAB_CONFIRMATION: "The requested information will open on a new browser tab. You can always come back to this tab to continue working on it.<br/><br/>Please remember that clicking 'Save' on the new tab won't save anything on this tab.",
  PLEASE_SELECT_DISCOUNTING_TYPE: "Please select 'Discount Type' for selected rows.",
  INVOICE_REQUESTED_STATUS_ERROR: "You can't move this record to 'Invoice requested' because the Title transfer date is after Valuation date.",
  COMPLETED_STATUS_FIELDS_AVAILABLE_CONFIRMATION: "Are you sure you want to move this record to 'Completed' status?.",
  COMPLETED_STATUS_FIELDS_NOT_AVAILABLE_CONFIRMATION: "You did not fill all fields. Are you sure you want to move this record to 'Completed' status?",
  INACTIVE_BANK_STATUS_ERROR: "You can't progress this record to next status because the Bank is inactive.<br/>You have to revert this record to 'Bank arranged', and select an active Bank.",
  PREVIOUS_STATUS_CONFIRMATION: "Are you sure you want to revert this record to previous status?",
  DELETE_DISCOUNTING_CONFIRMATION: "Are you sure you want to delete this record?",
  DELETE_DISCOUNTING_RECORD_ERROR: "You can't delete this record. You have to revert the status of this record below 'Bank Signed' to delete it.",
  DELETE_DISCOUNTING_PARCEL_ERROR: "You can't delete this parcel. You have to revert the status of the discount record below 'Invoice Provided' to delete this parcel.",
  ADD_DISCOUNTING_PARCEL_ERROR: "You can't add this parcel. You have to revert the status of the discount record below 'Invoice Provided' to add parcels.",
  Fill_MANDATORY_FIELDS_ERROR: "Please fill all mandatory fields.",
  PARCEL_PAYMENT_DUE_DATE_DIFFERENT: "The settlement date of the parcel(s) you are trying to add are not the same as the parcel(s) within this record.<br/>Are you sure you want to add parcel(s)?",
  DISCOUNTING_SAVE_SUCCESS: "Discount records are saved.",
  LCR_SAVE_SUCCESS: "LC Receivable records are saved.",
  DISCOUNTING_SAVE_ERROR: "Couldn't save discount records. Please try again.",
  LCR_SAVE_ERROR: "Couldn't save LC Receivable records. Please try again.",
  DISCARD_DISCOUNTING_CHANGES: "You changed records. If you continue without Saving you will lose all changes. How do you want continue?",
  DELETE_COLLATERAL_PARCEL_CONFIRMATION: "Are you sure, you want to remove this record? ",
  COLLATERAL: "Collateral",
  PARCELS: "Parcels",
  LC: "LC",
  CASH: "Cash",
  NOCOLLATERAL: "No Collateral",
  OPEN_URL_NEW_POPUP_CONFIRMATION: "The requested information will open and you can always come back to this tab to continue working on it.<br/><br/>Please remember that clicking 'Save' on the new tab won't save anything on this tab.",
  PLEASE_SAVE_BEFORE_MOVING_TO_NEXT_PAGE: "Please save the changes before moving to next page.",
  LETTER_OF_CREDIT_WITH_LCR_VALIDATION_MESSAGE: "There is an associated LCR Record with higher Status, so LC cannot be {1}, please revert the associated LCR record to a lower status to {0}",
  LETTER_OF_CREDIT_WITH_CLAIM_VALIDATION_MESSAGE: "Claims exists for this LC, please delete the claims first to {0}",
  CHANGE_THE_LC_STATUS: "change the LC status.",
  DISABLE_THE_LC: "disable the LC.",
  DISABLED: "disabled",
  MOVED_TO_STATUS: "moved to status {0}",
  CREATE_LC_FOR_THIS_PARCEL: "Create LC for this parcel",
  CREATE_CASH_FOR_THIS_PARCEL: "Create Cash for this parcel",
  RELEASE_THIS_PARCEL: "Release this parcel",
  RELEASE_ALL_SELECTED_PARCELS: "Release all selected parcels",
  LCSTATUS_APPROVED_REVERT_STATUS_ERROR: "You can't revert status from 'Bank Arranged' to 'New' because LC status is approved.",
  LCSTATUS_PENDING_OR_DISABLED_ERROR: "You can't change the status of the LCR, because the relevant LC status is either Disable or Pending approval.",
  CI_RUNOFFPERIOD_EXPIRY_ERROR: "Endorsement Expiry Date along with Run-off period is greater the Policy End Date.",
  LC_SETTLEMENTDATE_CONFIRMATION: "Expiry date should be greater than the settlement date of the parcel",
  CONTINUE: 'Continue',
  CANCEL: 'Cancel',
  PCG_BENEFICIARY_CONFIRMATIN_MESSAGE: "If you delete a Covered Party, the related Trade(s) Covered will be removed as well. Are you sure you want to continue?",
  PCG_RECEIPIENT_CONFIRMATIN_MESSAGE: "If you delete a Recipient, the related Trade(s) Covered will be removed as well. Are you sure you want to continue?",
  PCG_TRADE_DELETE_CONFIRMATIN_MESSAGE: "Are you sure, you want to delete '{0}'?",
  DELETE: "Delete",
  TRADE_DELETE_OURENITY_CONFIRMATION_MESSAGE: "If you change the our entity, the associated trade(s) covered will be removed as well. Are you sure you want to continue?",
  TRADE_DELETE_CPTY_CONFIRMATION_MESSAGE: "If you change the counterparty, the associated trade(s) covered will be removed as well. Are you sure you want to continue?",
  TITLE_TRANSFER_DATE_IS_GREATER_THAN_VALUATION_DATE: 'Title transfer date is greater than valuation date.',
  TRADING_COUNTERPARTY_ENTITY_ASSOCIATION_MESSAGE: "User does not have permission to Trading Counterparty",

  FAILURE_MESSAGE_FOR_User_Dont_HAVE_PERMISSION: "You don't have permission to Enable or Disable some of the items.",
  AGREEMENT_DUPLICATE_MESSAGE: " Another agreement(s) with the same combination of Counterparty, Our Entity and Type already exists. Are you sure you want to Continue? ",
  SAVE_THE_DETAILS_BEFORE_MODIFYING_ANYOTHER_ENTITY: "Please save the changes before updating other entity details.",
  OURENTITY: "Our entity",
  // Vidhathri - CRD-2628 -START
  GIVEN_LC_NEW: "Given LC: New value should be less than zero",
  GIVEN_LC_INCREASE: "Given LC: Increase value should be less than zero",
  GIVEN_LC_DECREASE: "Given LC: Decrease value should be greater than zero",
  RECEIVED_LC_NEW: "Received LC: New value should be greater than zero",
  RECEIVED_LC_INCREASE: "Received LC: Increase value should be greater than zero",
  RECEIVED_LC_DECREASE: "Received LC: Decrease value should be less than zero",
  CALL_MEMO_EXISTS: "Transaction with the same callmemo already exists. Please select another call memo",
  TRANSACTION_AMOUNT_ZERO: "Cannot add the selected call memo as call amount is zero.",
  GIVEN_LC_NEW_GRID: "Given LC: New value flowing from call memo should be less than zero. Please select another call memo",
  RECEIVED_LC_NEW_GRID: "Received LC: New value flowing from call memo should be greater than zero. Please select another call memo",
  MULTIPLE_UNAPPROVED_TRANSACTIONS_IN_GRID: "More than one Unapproved Transactions cannot be sent for approval. Please uncheck the 'approval required' checkbox against each transaction to approve it and proceed.",
  GIVEN_LC_APPROVED_AMOUNT_GREATER_THAN_ZERO: "For Given LC, the approved amount cannot be greater than zero since it flows as a transaction amount. Please correct the approved amounts to proceed further.",
  PERMISSON_MESSAGE: "User does not have permission to",
  DELETE_TRADE_CONFIRMATION: "Modifying the LC coverage will impact the associated LCR's or Claims.<br/>Do you want to proceed with change of LC coverage?",
  TRADE_COMPLETED_LCR: "This row is locked because the LCR status is \'Completed\'.",
  TRADE_MOVED_TO_HISTORY: "This row is locked because the trade is moved to the history table.",
  TRADE_COMPLETED_AND_MOVED_TO_HISTORY_LCR: "This row is locked because the LCR status is \'Completed\' and the trade is moved to the history table.",
  TRADE_COMPLETED_DISCOUNTING: "This row is locked because the Discount status is \'Completed\'.",
  TRADE_COMPLETED_AND_MOVED_TO_HISTORY_DISCOUNTING: "This row is locked because the Discount status is \'Completed\' and the trade is moved to the history table.",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE: "Are you sure, you want to delete?",
  RECEIVED_LC_APPROVED_AMOUNT_LESSER_THAN_ZERO: "For Received LC, the approved amount cannot be less than zero since it flows as a transaction amount. Please correct the approved amounts to proceed further.",
  // Vidhathri - CRD-2628 - END
  CANCEL_CONFIRMATION: "Are you sure to discard all changes?",
  DOCUMENT_TEMPLATE_VIEWNAME_MANDATORY_CONDITION: "Please enter View name.",
  DOCUMENT_TEMPLATE_TEMPLATENAME_MANDATORY_CONDITION: "Please enter Template name.",
  DOCUMENT_CATEGORY_CATEGORYNAME_MANDATORY_CONDITION: "Please enter Category name.",
  DOCUMENT_TEMPLATE_TEMPLATECONTENT_MANDATORY_CONDITION: "The Template content cannot be blank.",
  DOCUMENT_TEMPLATE_ERROR: "Error",
  DOCUMENT_TEMPLTE_MANDATORY_CONDITION: 'Please make sure you have selected a template and the content is not empty',
  DOCUMENT_MANAGEMENT_SAVE_SUCCESS_MESSAGE: "Saved successfully.",
  USER_SAVE_SUCCESS_MESSAGE: "User saved successfully.",
  USER_SAVE_FAILURE_MESSAGE: "Error has occured. Please see the event log for more information.",
  // Vidhathri - PD-668 - START
  PLEASE_SELECT_A_CALL_MEMO: "Please select a call memo to add",
  CANNOT_CHANGE_CALL_DIRECTION: "Cannot change the direction of Call Amount",
  PORTFOLIO_DUPLICATE_INSERTION: "Cannot insert duplicate key",
  DELETE_TRADE_CONFIRMATION_CSA: "Deleting the excluded trade will impact the Margining.<br>Do you want to proceed with deletion and start including the trade(s) in margining?",
  CSA_EXISTS_FOR_THE_TRADETYPE_PRODUCT_COMBINATION: "The selected combination of one or more Products and Trade Types is already covered by another CSA with the same combination of Agreements, Counterparty and Our Entity. Please correct it to proceed further.",
  FAILD_TO_UPDATE_PARENT_AGREEMENT_BECAUSE_OF_DATE_VALIDATION_IN_CHILD: "Effective date of one or more inherited child agreement(s) is later than the review or expiry date of the parent agreement. Please adjust the dates to proceed.",
  FORM_DATA_UPLOAD_FILE_FORMAT: "files",
  GUARANTEE_EXPIRY_DATE_ERROR: "Expiry Date is invalid.",
  GUARANTEE_EFFECTIVE_DATE_ERROR: "Effective Date is invalid.",
  SWITCHING_TO_AUTOMATED_CONFIRMATION: "If you switch to Automated, all manually added trades will be deleted.<br><br>Are you sure you want to switch?",
  SWITCHING_FROM_AUTOMATED_TO_MANUAL_CONFIRMATION: "If you switch to Manual entry, all automatically added trades will be deleted.<br><br>Are you sure you want to switch?",
  AUTOMATED_CONFIGURATION_ALREADY_ERROR_MESSAGE: "An LC with the same Contract, Product, Trade Type and overlapping Date Range configuration already exists.<br><br>Please review and amend the configuration.",
  AUTOMATED_CONFIGURATION_ALREADY_TITLE: "An LC with this configuration already exists.",
  CONTRACTS_ALREADY_EXISTS_IN_AUTOMATED_ENTRY_MESSAGE: "The following contracts are already included in an automated entry:<br><br>{0}<br><br>These contracts will be removed from the automation.<br><br>Are you sure you want to continue?",
  CONTRACTS_ALREADY_EXISTS_IN_AUTOMATED_ENTRY_TITLE: "Contract(s) already added to an automated entry."
};
